import { call, put, takeLatest } from "@redux-saga/core/effects";
import { jarvisPrimeInvestMoreApis } from "./jarvisPrimeInvestMoreApis";
import { jarvisPrimeInvestMoreParsers } from "./jarvisPrimeInvestMoreParsers";
import { jarvisPrimeInvestMoreConstants } from "./jarvisPrimeInvestMoreConstants";

import { tracker } from "library/tracker";

function* getInvestmentStocksSaga() {
    try {
        yield put({ type: jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_STOCKS_REQUEST });

        const res = yield call(jarvisPrimeInvestMoreApis.getInvestmentStocks);
        const payload = jarvisPrimeInvestMoreParsers.investmentStocks(res);
        yield put({
            type: jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_STOCKS_RESPONSE,
            payload,
        });
        // NOTE : event_tracker => investMore
        tracker.investMore.investMoreSuccess();
    } catch (error) {
        yield put({
            type: jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_STOCKS_RESPONSE,
            payload: {},
        });
        // NOTE: event_tracker => investMore
        tracker.investMore.investMoreTabFailed({ error_msg: error.messgae })
    }
}

export function* registerjarvisPrimeInvestMoreSagas() {
    yield takeLatest(
        jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_STOCKS_SAGA,
        getInvestmentStocksSaga
    );
}
